import {AdditionalProps} from 'modules/additionals/types';
import useApiQuery from 'shared/hooks/use-api-query';
import additionalGroupsKeys from '../util/additional-groups-keys';

const useAdditionalGroupAdditionals = (additionalGroupId: string) => {
  return useApiQuery<AdditionalProps[]>({
    url: `/additional-groups/${additionalGroupId}/additionals`,
    queryKey: additionalGroupsKeys.additionals(additionalGroupId),
  });
};

export default useAdditionalGroupAdditionals;
